/**
 * ID.me military discount (Discountify).
 *
 * Apply Discount opens the same checkpoint popup the checkout script used.
 * ID.me sends that popup back to the store with ?popup or ?error, and that
 * return is not always the military page, so this file loads on every page.
 * ?popup sends the original tab to checkout and closes the popup. ?error
 * just closes it.
 */

const VERIFY_WIDTH = 800;
const VERIFY_HEIGHT = 780;

const checkoutUrl = document.body?.dataset.idmeCheckout;

const returnParams = new URLSearchParams(window.location.search);

if (returnParams.get('popup') && checkoutUrl) {
  if (window.opener) {
    window.opener.location.href = checkoutUrl;
    window.close();
  } else {
    window.location.href = checkoutUrl;
  }
} else if (returnParams.get('error')) {
  window.close();
}

if (!customElements.get('military-discount-verify')) {
  customElements.define(
    'military-discount-verify',
    class MilitaryDiscountVerify extends HTMLElement {
      constructor() {
        super();
        this.onClick = this.onClick.bind(this);
      }

      connectedCallback() {
        this.button = this.querySelector('button');
        this.button?.addEventListener('click', this.onClick);
      }

      disconnectedCallback() {
        this.button?.removeEventListener('click', this.onClick);
      }

      onClick(event) {
        event.preventDefault();

        const body = document.body;
        const html = document.documentElement;
        const height = Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);
        const width = Math.max(body.scrollWidth, body.offsetWidth, html.clientWidth, html.scrollWidth, html.offsetWidth);
        const top = (height - VERIFY_HEIGHT) / 4;
        const left = (width - VERIFY_WIDTH) / 2;

        window.open(
          this.dataset.verifyUrl,
          '',
          `scrollbars=yes,menubar=no,status=no,location=no,toolbar=no,width=${VERIFY_WIDTH},height=${VERIFY_HEIGHT},top=${top},left=${left}`,
        );
      }
    },
  );
}
